import request from '../request.js';

/**
 * Получить список билетов ученика
 * @param {String} hash
 * @return {Promise}
 */
export const getStudentTickets = (hash) => {
  return request({
    url: '/bulk-buy-student/tickets',
    type: 'GET',
    needOverlay: true,
    data: {
      hash,
    },
  });
};

/**
 * Добавить место в корзину (ученик)
 * @param {String} hash
 * @param {int} viewId
 * @param {int} sid
 * @param {int} serviceId
 * @return {Promise}
 */
export const addStudentTicketToCart = (hash, viewId, sid, serviceId) => {
  console.log(sid);
  return request({
    url: '/bulk-buy-student/add-to-cart',
    type: 'POST',
    needOverlay: true,
    data: {
      hash,
      viewId,
      sid,
      serviceId,
    },
  });
};
